module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedMedium.5aba212.woff2";